import { EnumSchema, Omit, Replace } from '@40seas/entities/common';
import { BaseEntityFieldsArray, Currency } from '@40seas/models';
import { BankAccountDetailsSchema, BankAccountLocation } from './bank-account-details.entity';
import { BankAccount } from './bank-account.entity';

const CreateBankAccountDetailsSchema = BankAccountDetailsSchema.extend({
    currency: EnumSchema(Currency),
    location: EnumSchema(BankAccountLocation),
}).openapi({ ref: 'CreateBankAccountDetails' });

export class CreateBankAccountDto extends Omit(
    Replace(BankAccount, [
        {
            fieldName: 'bankAccountDetails',
            newFieldSchema: CreateBankAccountDetailsSchema,
        },
    ]),
    BaseEntityFieldsArray,
) {}
